// Event, Dialog
import EventBus from "@/event/EventBus";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

// Constant
import { SERVICE_TYPE } from '@/constant/rental';

export default {

    extends: baseRentalService,

    created() {
        EventBus.$on("processingEventRental", this.processingEvent);
        this.machineListRequest.serviceType = SERVICE_TYPE.CPUHUB;
        this.machineListView();
        this.timer = setInterval(this.autoRefresh, 10000)
    },

    beforeDestroy() {
        clearInterval(this.timer)
    }
}